export function load() {
    return {
        withoutSubheader: true,
        withoutFooter: true,
    }
}